import React, { useState } from 'react';
import { Div, Input, Label, P, Span } from '@kizi/core-components';
import { IconV2 } from '@kizi/shared-components';
import { useField, usePage } from '@kizi/comparator-core';

interface PriceCapBannerProps {
  togglerText: string;
  fieldname: string;
  backgroundColor?: string;
  text: string;
  isHidden: boolean;
}

export const PriceCapBanner = ({
  backgroundColor,
  fieldname,
  togglerText,
  text,
  isHidden = false,
  ...rest
}: PriceCapBannerProps) => {
  const isPriceCapActiveField = useField(fieldname);
  const isPriceCapActive = isPriceCapActiveField?.value;

  const { state }: any = usePage();
  const hasProducts = state?.productList?.length > 0;

  const [isToggled, setIsTogled] = useState(Boolean(isPriceCapActive));

  if (isHidden || !hasProducts) {
    return null;
  }
  return (
    <Div
      p={4}
      display="flex"
      justifyContent="space-between"
      alignItems="flex-start"
      flexDirection={['column', null, 'row']}
      backgroundColor={backgroundColor}
      borderRadius={2}
      {...rest}
    >
      <Div alignSelf={['flex-start', null, 'center']}>
        <IconV2 size={20} name="savings" />
      </Div>

      <P
        variant="bodyRegularToCaption"
        my={[3, null, 0]}
        ml={[0, null, 4]}
        mr={[0, null, 2]}
        dangerouslySetInnerHTML={{ __html: text }}
      />

      <Div width={['100%', null, 'auto']} display="flex" alignItems="center">
        <P
          flex={1}
          fontWeight={1}
          minWidth="120px"
          variant="bodyRegularToCaption"
        >
          {togglerText}
        </P>

        <Label variant="switcher">
          <Input
            onClick={() => {
              setIsTogled(!isToggled);
              isPriceCapActiveField?.set({
                value: isPriceCapActive === 1 ? 0 : 1,
              });
            }}
            checked={isToggled}
            variant="switcherCheckbox"
            type="checkbox"
          />
          <Span />
        </Label>
      </Div>
    </Div>
  );
};
